/* Exotic India — smoothness helpers (image load states + scroll reveals) */
(function () {
  // ---- Toasts -------------------------------------------------------------
  function toastHost() {
    var host = document.querySelector('.ex-toasts');
    if (!host) {
      host = document.createElement('div');
      host.className = 'ex-toasts';
      host.setAttribute('data-testid', 'toast-host');
      document.body.appendChild(host);
    }
    return host;
  }

  var ICONS = {
    cart: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 12l5 5L20 6"/></svg>',
    heart: '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21.2l8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/></svg>',
    info: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 8h.01M11 12h1v5h1"/></svg>'
  };

  window.exToast = function (opts) {
    var o = opts || {};
    var el = document.createElement('div');
    el.className = 'ex-toast';
    el.setAttribute('data-testid', 'toast');
    el.innerHTML =
      '<span class="ex-toast__icon">' + (ICONS[o.icon] || ICONS.info) + '</span>' +
      '<span class="ex-toast__text"><strong>' + (o.title || '') + '</strong>' +
      (o.subtitle ? '<span>' + o.subtitle + '</span>' : '') + '</span>' +
      (o.linkHref ? '<a class="ex-toast__link" href="' + o.linkHref + '">' + (o.linkLabel || 'View') + '</a>' : '');
    toastHost().appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); }, 320);
    }, o.duration || 3200);
  };

  // Wishlist toasts (the toggle itself lives in the header section)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    // The header handler flips the class synchronously, so read it next tick.
    setTimeout(function () {
      var added = btn.classList.contains('is-active');
      window.exToast({
        icon: 'heart',
        title: added ? 'Saved to your wishlist' : 'Removed from your wishlist',
        subtitle: btn.dataset.title || '',
        linkHref: added ? '/pages/wishlist' : null,
        linkLabel: 'View wishlist'
      });
    }, 0);
  });


  // Add-to-cart: confirm with a toast, then continue to the cart page
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d && res.d.description ? res.d.description : 'Could not add to bag');
        window.exToast({
          icon: 'cart',
          title: 'Added to your bag',
          subtitle: res.d.product_title || '',
          linkHref: '/cart', linkLabel: 'View bag'
        });
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
        }).catch(function () {});
        setTimeout(function () { window.location.href = '/cart'; }, 1100);
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        window.exToast({ icon: 'info', title: 'Could not add to bag', subtitle: String(err.message || err) });
      });
  });

  var FRAME_SELECTOR = '.ex-pcard__frame, .exotic-tile__frame, .ex-pdp-journal__frame, .ex-mega__hero, .ex-pdp__main-img, .ex-pdp__thumb';

  function markLoaded(img) {
    var frame = img.closest(FRAME_SELECTOR);
    if (frame) frame.classList.add('is-img-loaded');
  }

  function watchImages(root) {
    (root || document).querySelectorAll(FRAME_SELECTOR + ' img').forEach(function (img) {
      if (img.complete && img.naturalWidth) markLoaded(img);
      else {
        img.addEventListener('load', function () { markLoaded(img); }, { once: true });
        img.addEventListener('error', function () { markLoaded(img); }, { once: true });
      }
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  }

  function watchReveals() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.ex-reveal').forEach(function (el) { io.observe(el); });
  }

  function init() {
    watchImages(document);
    watchReveals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-scan when Shopify re-renders a section in the theme editor / after AJAX
  document.addEventListener('shopify:section:load', function (e) { watchImages(e.target); });
  window.addEventListener('load', function () { watchImages(document); });
})();
